
import { ref } from '@nuxtjs/composition-api'

export default {
  props: {
    // allow overriding defaults per-usage
    sizes: { type: String, default: '' },
    loading: { type: String, default: '' }
  },
  setup (props) {
    const hasError = ref(false)
    const onError = () => {
      hasError.value = true
    }
    // const defaultSizes = '(max-width: 600px) 50vw, (max-width: 1264px) 33vw, 25vw'
    // const sizesAttr = props.sizes && props.sizes.trim().length > 0 ? props.sizes : defaultSizes
    const loadingAttr = props.loading && props.loading.trim().length > 0 ? props.loading : 'lazy'

    return {
      onError,
      hasError,
      // sizesAttr,
      loadingAttr
    }
  }
}
